import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Newsletter from "@/pages/Newsletter";

export const Route = createFileRoute("/en/subscribe")({
  head: () => buildRouteHead("/en/subscribe"),
  component: Newsletter,
});

